// THIS FILE WAS GENERATED AND SHOULD NOT BE MODIFIED!
import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import { path } from './basename';
import ComponentAdditionalMenuPage from './Components/AdditionalMenuPage';
import ComponentAlertsPage from './Components/AlertsPage';
import ComponentBadgePage from './Components/BadgePage';
import ComponentBannerPage from './Components/BannerPage';
import ComponentBlogThumbPage from './Components/BlogThumbPage';
import ComponentBreadcrumbsPage from './Components/BreadcrumbsPage';
import ComponentButtonsPage from './Components/ButtonsPage';
import ComponentCardPage from './Components/CardPage';
import ComponentCarouselPage from './Components/CarouselPage';
import ComponentCategoryListPage from './Components/CategoryListPage';
import ComponentCheckableBoxPage from './Components/CheckableBoxPage';
import ComponentCheckboxListPage from './Components/CheckboxListPage';
import ComponentChipPage from './Components/ChipPage';
import ComponentContentPage from './Components/ContentPage';
import ComponentCourseImagePage from './Components/CourseImagePage';
import ComponentCoverPage from './Components/CoverPage';
import ComponentDropdownsPage from './Components/DropdownsPage';
import ComponentFadePage from './Components/FadePage';
import ComponentFormPage from './Components/FormPage';
import ComponentHighlightPage from './Components/HighlightPage';
import ComponentImageBadgePage from './Components/ImageBadgePage';
import ComponentImagePage from './Components/ImagePage';
import ComponentLayoutPage from './Components/LayoutPage';
import ComponentLinkButtonPage from './Components/LinkButtonPage';
import ComponentModalsPage from './Components/ModalsPage';
import ComponentPillsMenuPage from './Components/PillsMenuPage';
import ComponentProgressPage from './Components/ProgressPage';
import ComponentRatingsPage from './Components/RatingsPage';
import ComponentSearchPage from './Components/SearchPage';
import ComponentSeparatorPage from './Components/SeparatorPage';
import ComponentSkeletonPage from './Components/SkeletonPage';
import ComponentSliderPage from './Components/SliderPage';
import ComponentSpinnerPage from './Components/SpinnerPage';
import ComponentStickyBarPage from './Components/StickyBarPage';
import ComponentTabsPage from './Components/TabsPage';
import ComponentTestimonialPage from './Components/TestimonialPage';
import ComponentTilePage from './Components/TilePage';
import TypographyBannerPage from './Typography/BannerPage';
import TypographyHeadingsPage from './Typography/HeadingsPage';
import TypographyIconBoxPage from './Typography/IconBoxPage';
import TypographyIconListPage from './Typography/IconListPage';
import TypographyIconsPage from './Typography/IconsPage';
import TypographySubtitlePage from './Typography/SubtitlePage';
import UtilityClearfixPage from './Utilities/ClearfixPage';
import UtilityColorsPage from './Utilities/ColorsPage';
import UtilityFontPage from './Utilities/FontPage';
import UtilityShadowsPage from './Utilities/ShadowsPage';
import UtilitySpacingPage from './Utilities/SpacingPage';
import UtilityTruncatePage from './Utilities/TruncatePage';
import CompositionAdvancedCardsPage from './Compositions/AdvancedCardsPage';
import CompositionAvatarPartnerPage from './Compositions/AvatarPartnerPage';
import CompositionBoxesPage from './Compositions/BoxesPage';
import CompositionCookieBannerPage from './Compositions/CookieBannerPage';
import CompositionDropdownMenusPage from './Compositions/DropdownMenusPage';
import CompositionFilterBoxPage from './Compositions/FilterBoxPage';
import CompositionHeaderPage from './Compositions/HeaderPage';
import CompositionHorizontalCardsPage from './Compositions/HorizontalCardsPage';
import Home from './Home';
import NotFound from './NotFound';
import Components from './Components';
import Utilities from './Utilities';
import UI from './UI';
import Typography from './Typography';
import Compositions from './Compositions';
const defaultPage = process.env.NODE_ENV === 'production' ? Home : NotFound;
const routes = (<Route path={path()} component={UI.Layout}>
        <IndexRoute component={Home}/>
        <Route path={path('components/')} component={Components}>
            <IndexRedirect to="additional-menu/"/>
            <Route path="additional-menu/" component={ComponentAdditionalMenuPage}/>
            <Route path="alerts/" component={ComponentAlertsPage}/>
            <Route path="badge/" component={ComponentBadgePage}/>
            <Route path="banner/" component={ComponentBannerPage}/>
            <Route path="blog-thumb/" component={ComponentBlogThumbPage}/>
            <Route path="breadcrumbs/" component={ComponentBreadcrumbsPage}/>
            <Route path="buttons/" component={ComponentButtonsPage}/>
            <Route path="card/" component={ComponentCardPage}/>
            <Route path="carousel/" component={ComponentCarouselPage}/>
            <Route path="category-list/" component={ComponentCategoryListPage}/>
            <Route path="checkable-box/" component={ComponentCheckableBoxPage}/>
            <Route path="checkbox-list/" component={ComponentCheckboxListPage}/>
            <Route path="chip/" component={ComponentChipPage}/>
            <Route path="content/" component={ComponentContentPage}/>
            <Route path="course-image/" component={ComponentCourseImagePage}/>
            <Route path="cover/" component={ComponentCoverPage}/>
            <Route path="dropdowns/" component={ComponentDropdownsPage}/>
            <Route path="fade/" component={ComponentFadePage}/>
            <Route path="form/" component={ComponentFormPage}/>
            <Route path="highlight/" component={ComponentHighlightPage}/>
            <Route path="image-badge/" component={ComponentImageBadgePage}/>
            <Route path="image/" component={ComponentImagePage}/>
            <Route path="layout/" component={ComponentLayoutPage}/>
            <Route path="link-button/" component={ComponentLinkButtonPage}/>
            <Route path="modals/" component={ComponentModalsPage}/>
            <Route path="pills-menu/" component={ComponentPillsMenuPage}/>
            <Route path="progress/" component={ComponentProgressPage}/>
            <Route path="ratings/" component={ComponentRatingsPage}/>
            <Route path="search/" component={ComponentSearchPage}/>
            <Route path="separator/" component={ComponentSeparatorPage}/>
            <Route path="skeleton/" component={ComponentSkeletonPage}/>
            <Route path="slider/" component={ComponentSliderPage}/>
            <Route path="spinner/" component={ComponentSpinnerPage}/>
            <Route path="sticky-bar/" component={ComponentStickyBarPage}/>
            <Route path="tabs/" component={ComponentTabsPage}/>
            <Route path="testimonial/" component={ComponentTestimonialPage}/>
            <Route path="tile/" component={ComponentTilePage}/>
        </Route>
        <Route path={path('compositions/')} component={Compositions}>
            <IndexRedirect to="advanced-cards/"/>
            <Route path="advanced-cards/" component={CompositionAdvancedCardsPage}/>
            <Route path="avatar-partner/" component={CompositionAvatarPartnerPage}/>
            <Route path="boxes/" component={CompositionBoxesPage}/>
            <Route path="cookie-banner/" component={CompositionCookieBannerPage}/>
            <Route path="dropdown-menus/" component={CompositionDropdownMenusPage}/>
            <Route path="filter-box/" component={CompositionFilterBoxPage}/>
            <Route path="header/" component={CompositionHeaderPage}/>
            <Route path="horizontal-cards/" component={CompositionHorizontalCardsPage}/>
        </Route>
        <Route path={path('typography/')} component={Typography}>
            <IndexRedirect to="banner/"/>
            <Route path="banner/" component={TypographyBannerPage}/>
            <Route path="headings/" component={TypographyHeadingsPage}/>
            <Route path="icon-box/" component={TypographyIconBoxPage}/>
            <Route path="icon-list/" component={TypographyIconListPage}/>
            <Route path="icons/" component={TypographyIconsPage}/>
            <Route path="subtitle/" component={TypographySubtitlePage}/>
        </Route>
        <Route path={path('utilities/')} component={Utilities}>
            <IndexRedirect to="clearfix/"/>
            <Route path="clearfix/" component={UtilityClearfixPage}/>
            <Route path="colors/" component={UtilityColorsPage}/>
            <Route path="font/" component={UtilityFontPage}/>
            <Route path="shadows/" component={UtilityShadowsPage}/>
            <Route path="spacing/" component={UtilitySpacingPage}/>
            <Route path="truncate/" component={UtilityTruncatePage}/>
        </Route>
        <Route path="*" component={defaultPage}/>
    </Route>);
export default routes;
